import { useEffect, useRef } from "react";
import { ToggleButton } from "../HeadingToggle";
import { Icon } from "../Icon";
import { Tooltip } from "../Tooltip";
import {
  SearchBarCount,
  SearchBarIcon,
  SearchBarInput,
  SearchBarRow,
} from "./searchBarStyles";

type Props = {
  query: string;
  matchCount: number;
  onChange: (query: string) => void;
  onClose: () => void;
};

export function TableSearchBar({
  query,
  matchCount,
  onChange,
  onClose,
}: Props) {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
    inputRef.current?.select();
  }, []);

  const countText = !query
    ? ""
    : matchCount === 0
      ? "No results"
      : `${matchCount} result${matchCount === 1 ? "" : "s"}`;

  return (
    <SearchBarRow>
      <SearchBarIcon>
        <Icon name="search" size={12} />
      </SearchBarIcon>
      <SearchBarInput
        ref={inputRef}
        type="text"
        placeholder="Filter table…"
        value={query}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Escape") {
            e.preventDefault();
            onClose();
          }
        }}
        spellCheck={false}
      />
      {countText && <SearchBarCount>{countText}</SearchBarCount>}
      <Tooltip content="Close">
        <ToggleButton onMouseDown={(e) => e.preventDefault()} onPress={onClose}>
          <Icon name="x" size={12} />
        </ToggleButton>
      </Tooltip>
    </SearchBarRow>
  );
}
